// Shared visual helpers for driver / sponsor surfaces

export const MEDIA_TONES = {
  podium: "from-[#1A1A1F] to-[#2A2A33] text-white",
  video: "from-[#F25E1D] to-[#9E2C00] text-white",
  data: "from-[#1F3A5F] to-[#0E1F36] text-white",
  paddock: "from-[#2C2C34] to-[#42434E] text-white",
};

export function formatGBP(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(n);
}

export function relDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const days = Math.round((Date.now() - d.getTime()) / 86400000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 14) return `${days}d ago`;
  if (days < 60) return `${Math.round(days / 7)}w ago`;
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short" });
}

export function ordinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
